var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Chevron arrow pointing down",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m11.75 13.689 4.47-4.47a.749.749 0 1 1 1.06 1.06l-4.678 4.68a1.204 1.204 0 0 1-1.704 0l-4.678-4.68a.75.75 0 1 1 1.06-1.06z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDown;